<div class="main-container mat-app-background">
  <lfw-navigation-toolbar>
    <ng-container navCenter>
      <div class="doublelined">
        <div class="webdoku showIfEmpty">{{ projectName }}</div>
        <div class="infotext showIfEmpty">{{ infoText }}</div>
      </div>
    </ng-container>
  </lfw-navigation-toolbar>

  <main class="main-outlet-container">
    <ng-content />
  </main>

  @if (isMenuVisible) {
    <div class="footer">
      <ngx-bottom-nav class="bottombar" color="primary">
        @for (item of availableItems$ | async; track item.id) {
          <button
            ngx-bottom-nav
            label="{{ item.text }}"
            [routerLink]="item.route"
            routerLinkActive="active-link"
            [hideLabel]="false"
            [icon]="item.icon">
            <mat-icon ngxBottomNavIcon>{{ item.icon }}</mat-icon>
          </button>
        }
        <button
          ngx-bottom-nav
          [label]="menuService.cmdUser?.text || ''"
          (click)="openUserBottomSheet()"
          [hideLabel]="false"
          [icon]="menuService.cmdUser?.icon || ''">
          <mat-icon ngxBottomNavIcon>{{ menuService.cmdUser?.icon }}</mat-icon>
        </button>
      </ngx-bottom-nav>
    </div>
  }
</div>
